/**
 * Apply a Redux patch, run the async commit, and revert the patch if commit fails.
 * `apply` runs synchronously before any await so callers can rebuild UI from store
 * immediately after dispatching the surrounding thunk.
 */
export async function withOptimisticUpdate<T>(options: {
  apply: () => void;
  revert: () => void;
  commit: () => Promise<T>;
}): Promise<T> {
  options.apply();
  try {
    return await options.commit();
  } catch (error) {
    options.revert();
    throw error;
  }
}
